import { ReactNode } from 'react';

import { PortalLinkContext } from '~/components/PortalLink';
import { SelectedEmployeeContextRootProvider } from '~/components/SelectedEmployee';
import { useAuthentication } from '~/data/user/useAuthentication';

type PropsType = {
  children?: ReactNode;
};

export const LibraryComponentProviders = (props: PropsType) => {
  const { children } = props;

  const { isAuthenticated, userDetails } = useAuthentication();

  return isAuthenticated && !!userDetails ? (
    <PortalLinkContext.Provider value={{ isRouteLinksEnabled: false }}>
      <SelectedEmployeeContextRootProvider>
        {children}
      </SelectedEmployeeContextRootProvider>
    </PortalLinkContext.Provider>
  ) : (
    <></>
  );
};
